/* global Vue $ headBlock */
(function () {
	var visible = false;
	const blocking = {};
	
	Vue.block = function (message) {
		blocking[undefined] = true;
		if (!visible)
		{
			visible = true;
			headBlock(message);
		}
	};
	
	Vue.unblock = function () {
		if (blocking[undefined])
		{
			delete blocking[undefined];
			if (Object.keys(blocking).length === 0)
			{
				visible = false;
				$.unblockUI();
			}
		}
	};

	Vue.mixin({
		methods: {
			block: function (message) {
				blocking[this.uuid] = true;
				if (!visible)
				{
					visible = true;
					headBlock(message);
				}
			},
			unblock: function () {
				if (blocking[this.uuid])
				{
					delete blocking[this.uuid];
					if (Object.keys(blocking).length === 0)
					{
						visible = false;
						$.unblockUI();
					}
				}
			},
		},
		beforeDestroy: function () {
			this.unblock();
		}
	});
})();